import { css } from 'lit';

import { transition } from '../../styles';

import color from '../../utils/get-color-token';
import token from '../../utils/get-token';
import toRem from '../../utils/to-rem';

function styles() {
	return css`
		.bar {
			display: flex;
			flex-grow: 0;
			flex-shrink: 1;
			align-items: center;
			justify-content: center;

			position: relative;
			overflow: hidden;

			width: 100%;
			height: ${toRem('8px')};

			border-radius: ${token('border-radius-s')};
			background-color: ${color('color-background-tertiary')};
		}

		.progress {
			position: absolute;
			top: 0;
			left: 0;

			${transition([{ property: 'width' }, { property: 'background' }])};

			height: ${toRem('8px')};

			border-radius: ${token('border-radius-s')};

			background: var(--m-progress-bar-progress-background);
		}

		.-default {
			--m-progress-bar-progress-background: linear-gradient(
				45deg,
				${color('color-brand-accent-1')} 22%,
				${color('color-brand-accent-2')} 88%
			);
		}

		.-success {
			--m-progress-bar-progress-background: ${color('color-success-60')};
		}

		.-warning {
			--m-progress-bar-progress-background: ${color('color-warning-60')};
		}

		.-danger {
			--m-progress-bar-progress-background: ${color('color-danger-60')};
		}
	`;
}

export default styles;
